import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { GroupedBracketedDiv } from "./AndGroupEditor";
import { ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import { LessThanEqualToExpression } from "../../../rule-engine-core/Expressions/Expressions/Logic/LessThanEqualToExpression";

export class LessThanEqualToExpressionEditor extends ExpressionRuleEditor<LessThanEqualToExpression> {
    render() {
        return (
            <GroupedBracketedDiv issue={this.ruleData!.getValidationIssues()[0]}>
                <ExpressionPiece>
                    <ExpressionValueRenderer el={this.ruleData!.value1!} />
                </ExpressionPiece>
                <ExpressionPiece> {"<="} </ExpressionPiece>
                <ExpressionPiece>
                    <ExpressionValueRenderer el={this.ruleData!.value2!} />
                </ExpressionPiece>
            </GroupedBracketedDiv>
        );
    }
}
